// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"da0580c8","598":"9f40438a","703":"b37640f4"}[chunkId] + ".chunk.js";
};